import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.collection-cards__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          destroy: true,
          breakpoints: {
            768: {
              type: 'slide',
              focus: 'center',
              arrows: false,
              gap: '20px',
              paginationKeyboard: true,
              autoWidth: true,
              destroy: false,
              drag: true,
              pagination: false,
              start: 1,
            },
          },
        } );
        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            drag: isOverflow,
          };
        } );
        slider.mount( );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'collection-cards', COMPONENT );
} )( app );
